import { Box, TextField } from "@mui/material";
import type { ChangeEvent } from "react";
import Divider from "@mui/material/Divider";
import SalesSelect from "./SaleSelect";
import CloseReasonSelect from "./CloseReasonSelect";
import WaterTestStatusSelect from "./WaterTestStatusSelect";
import type { DisasterStatusCardProps } from "../../../types";
import { deriveSaleStatus } from "../../../deriveSaleStatus";

const SaleStatus = ({
  disasterStatus,
  onSaleStatusChange,
}: Pick<DisasterStatusCardProps, "disasterStatus" | "onSaleStatusChange">) => {

  //営業状況管理: 1~4→sale_status=1, 5~6→0, 7またはnull→null
  const handleChangeSaleStatus = (e: number | null) => {
    if (!onSaleStatusChange) return;
    onSaleStatusChange({
      ...disasterStatus,
      sale_detail_status: e,
      sale_status: deriveSaleStatus(e),
    });
  };

  //休止要因管理
  const handleChangeReasonsClosingStatus = (e: number | null) => {
    if (!onSaleStatusChange) return;
    onSaleStatusChange({
      ...disasterStatus,
      reasons_closing_status: e,
    });
  };

  //休止要因管理
  const handleChangeWaterTestStatus = (e: number | null) => {
    if (!onSaleStatusChange) return;
    onSaleStatusChange({
      ...disasterStatus,
      water_test_status: e,
    });
  };

  //被害詳細管理
  const handleChangeReasonsClosing = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (!onSaleStatusChange) return;
    const newValue = e.target.value;
    // 親コンポーネントのステート変更
    onSaleStatusChange({
      ...disasterStatus,
      reasons_closing: newValue,
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "fit-content",
        justifyContent: "center",
        width: "100%",
        borderRadius: 2,
        borderTop: 16,
        borderColor: "primary.main",
        boxShadow: 3,
        color: "outline.dark",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "fit-content",
          justifyContent: "center",
          padding: "16px 40px 32px 40px",
          gap: "16px",
          "@media screen and (max-width:900px)": {
            padding: "16px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "min-content",
            fontSize: 20,
            fontWeight: "bold",
            color: "primary.main",
            whiteSpace: "nowrap",
          }}
        >
          営業状況
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            minWidth: "min-content",
            fontSize: 16,
            fontWeight: "bold",
            color: "#000",
            whiteSpace: "nowrap",
            "@media screen and (max-width:600px)": {
              width: "100%",
              flexDirection: "column",
            },
          }}
        >
          <Box sx={{ width: "248px" }}>営業状況</Box>
          <SalesSelect
            saleDetailStatus={disasterStatus?.sale_detail_status}
            changedValue={(e) => handleChangeSaleStatus(e)}
          />
        </Box>
        <Divider />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            minWidth: "min-content",
            fontSize: 16,
            fontWeight: "bold",
            color: "#000",
            whiteSpace: "nowrap",
            "@media screen and (max-width:600px)": {
              width: "100%",
              flexDirection: "column",
            },
          }}
        >
          <Box sx={{ width: "248px" }}>休止要因</Box>
          <CloseReasonSelect
            reasonsClosingStatus={disasterStatus?.reasons_closing_status}
            changedValue={(e) => handleChangeReasonsClosingStatus(e)}
          />
        </Box>
        <Divider />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            minWidth: "min-content",
            fontSize: 16,
            fontWeight: "bold",
            color: "#000",
            whiteSpace: "nowrap",
            "@media screen and (max-width:600px)": {
              width: "100%",
              flexDirection: "column",
            },
          }}
        >
          <Box sx={{ width: "248px" }}>浸水・冠水時検水対応</Box>
          <WaterTestStatusSelect
            waterTestStatus={disasterStatus?.water_test_status}
            changedValue={(e) => handleChangeWaterTestStatus(e)}
          />
        </Box>
        <Divider />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
            minWidth: "min-content",
            fontSize: 16,
            fontWeight: "bold",
            color: "#000",
            whiteSpace: "nowrap",
            "@media screen and (max-width:600px)": {
              width: "100%",
              flexDirection: "column",
            },
          }}
        >
          <Box sx={{ width: "248px" }}>再開見込</Box>
          <TextField
            name="reasonsClosingTextField"
            id="outlined-basic"
            variant="outlined"
            multiline
            rows={2}
            value={disasterStatus?.reasons_closing || ''}
            onChange={(e) => handleChangeReasonsClosing(e)}
            sx={{
              height: "100%",
              width: "100%",
              ".MuiInputBase-root": {
                height: "100%",
              },
              "#outlined-basic": {
                boxSizing: "border-box",
                height: "100%",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default SaleStatus;
